import React, { CSSProperties } from 'react';
import { TextWithDotStyles } from './TextWithDotStyles';

export function TextWithDot({
  text, className = '', extraDotStyles, children,
}: {text?: string, className?: string, extraDotStyles?: CSSProperties, children?: any}) {
  return (
    <TextWithDotStyles className={`textWithDot ${className}`}>
      <div className="dot" style={extraDotStyles} />

      {text && <p>{text}</p>}

      {children && children}

    </TextWithDotStyles>
  );
}
